export default () => `{
  "@context": "http://schema.org",
  "@type": "Organization",
  "url": "https://www.upgrade.com/",
  "name": "upgrade",
  "aggregateRating": {
  	"@type": "AggregateRating",
    "ratingValue": "4.8",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "5303",
    "reviewCount": "5303"
  }
}`;

export const generateBlogSchema = ({ title, image, itemList, datePublished, dateModified, url }) => {
  const blogSchema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: title,
    image: {
      '@type': 'ImageObject',
      url: image
    },
    publisher: {
      '@type': 'Organization',
      name: 'Upgrade',
      logo: {
        '@type': 'ImageObject',
        url: '/resources/UpgradeLogo-FullColor-V.png'
      }
    },
    datePublished,
    dateModified,
    mainEntityOfPage: {
      '@type': 'WebPage',
      url
    }
  };

  if (itemList?.length) {
    blogSchema.mainEntity = {
      '@type': 'ItemList',
      itemListElement: itemList.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Thing',
          name: item.name
        }
      }))
    };
  }

  return blogSchema;
};
